import { useScale } from "common/utils";
import { BASE_WIDTH, BASE_HEIGHT } from "common/constant";
import { BackgroundSvg } from "features/home/assets";

export const Footer = () => {
  const { width, height } = useScale();
  const scaleX = width / BASE_WIDTH;
  const scaleY = height / BASE_HEIGHT;

  return (
    <div
      className="flex-col-el flex-center absolute bottom-0 z-[-1]"
      style={{
        width: width,
        height: 235 * scaleY,
      }}
    >
      <div
        className="flex-col-center w-[1280px] h-[235px]"
        style={{ transform: `scale(${scaleX}, ${scaleY})` }}
      >
        <BackgroundSvg />
      </div>
    </div>
  );
};
